import React, { useState } from "react";
import "../Styles/Contact.scss";
import heroImg from "../Image/img18.JPG";

const Contact = () => {
    const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [showNotice, setShowNotice] = useState(false);

  // REGEX RULES
  const nameRegex = /^[A-Za-z\s]{2,}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let validationErrors = {};

    if (!nameRegex.test(formData.name)) {
      validationErrors.name = "Please enter a valid name.";
    }

    if (!emailRegex.test(formData.email)) {
      validationErrors.email = "Please enter a valid email address.";
    }

    if (formData.message.trim().length < 10) {
      validationErrors.message =
        "Message must be at least 10 characters long.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setShowNotice(true);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behaviour: "smooth",
    });
  };
  return (
    <section className="contact-page">
      {/* HERO */}
      <div
        className="contact-hero"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="overlay">
          <h1>CONTACT US</h1>
          <p>
            We are here to make your stay exceptional. Reach out anytime,
            comfort awaits.
          </p>
          <div className="buttons">
            <a href="/rooms" className="hero-btn" onClick={scrollToTop}>
              OUR ROOMS
            </a>
            <a href="/gallery" className="gallery-btn" onClick={scrollToTop}>
              OUR GALLERY
            </a>
          </div>
        </div>
      </div>

      {/* INFO + FORM */}
      <div className="contact-main">
        <div className="contact-info">
          <h1>Contact Us</h1>

          <div className="info-block">
            <h2>Phone</h2>
            <p>+355 67 673 7777</p>
          </div>

          <div className="info-block">
            <h2>Email</h2>
            <p>hotelkurti@gmail.com</p>
          </div>

          <div className="info-block">
            <h2>Address</h2>
            <p>Bulevardi i Pishave, Durrës 1000, Albania</p>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
      <h2>SEND A MESSAGE</h2>

      <input
        type="text"
        name="name"
        placeholder="Your Name"
        value={formData.name}
        onChange={handleChange}
      />
      {errors.name && <span className="error">{errors.name}</span>}

      <input
        type="email"
        name="email"
        placeholder="Your Email"
        value={formData.email}
        onChange={handleChange}
      />
      {errors.email && <span className="error">{errors.email}</span>}

      <textarea
        name="message"
        placeholder="Your Message"
        value={formData.message}
        onChange={handleChange}
      ></textarea>
      {errors.message && <span className="error">{errors.message}</span>}

      <button type="submit">SEND MESSAGE</button>

      {showNotice && (
        <div className="form-notice">
          <h4>Message Requests Unavailable</h4>
          <p>
            We are currently not accepting inquiries through this form.
            <br />
            Please reach us directly using the contact details provided on this
            page.
          </p>
        </div>
      )}
    </form>

        {/* <form className="contact-form">
          <h2>SEND A MESSAGE</h2>

          <input type="text" placeholder="Your Name" />
          <input type="email" placeholder="Your Email" />
          <textarea placeholder="Your Message"></textarea>

          <button type="submit">SEND MESSAGE</button>
        </form> */}
      </div>

      {/* MAP */}
      <div className="contact-map">
        <iframe
          title="Kurti Hotel Location"
          src="https://maps.google.com/maps?q=41.26613626801806,19.522997516674216&z=15&output=embed&iwloc=near"
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
};

export default Contact;
